import type { TTimeframePreset } from '@feathr/hooks';

// Re-export shared timeframe preset type from hooks
export type { TTimeframePreset } from '@feathr/hooks';

/**
 * Donation type filter options.
 */
export type TDonationType = 'one_time' | 'recurring';

/**
 * Donor option for the donor filter dropdown.
 * Stored on the filter state so selected pills render without re-fetching.
 */
export interface IDonorOption {
  id: string;
  name: string;
}

/**
 * Filter state for transaction table.
 */
export interface ITransactionFilters {
  /** Selected form IDs (empty = all forms) */
  formIds: string[];
  /**
   * Selected donors (empty = all donors). Stored as `{id, name}` so the
   * dropdown can render selected pills without an extra Persons lookup.
   */
  donors: IDonorOption[];
  /** Donation types to include (empty = all types) */
  donationTypes: TDonationType[];
  /** Timeframe preset or 'custom' for date range */
  timeframe: TTimeframePreset;
  /** Custom date range (only used when timeframe === 'custom') */
  customDateRange: { start: Date | null; end: Date | null };
}

/**
 * Default filter values (no filtering applied).
 */
export const DEFAULT_FILTERS: ITransactionFilters = {
  formIds: [],
  donors: [],
  donationTypes: [],
  timeframe: 'all_time',
  customDateRange: { start: null, end: null },
};
